import { Features } from '@aipb/env/model';
import { inject, Injectable, InjectionToken } from '@angular/core';

export const FEATURE_TOGGLE_FEATURES = new InjectionToken<Features>('FEATURE_TOGGLE_FEATURES');

@Injectable({
  providedIn: 'root'
})
export class FeatureToggleService {
  private features = inject(FEATURE_TOGGLE_FEATURES);

  isFeatureEnabled(feature: keyof Features): boolean {
    if (!(feature in this.features)) return false;

    // @ts-expect-error foo
    return this.features[feature];
  }
}
